import { render, staticRenderFns } from "./PredictorSelection.vue?vue&type=template&id=48bc2756"
import script from "./PredictorSelection.vue?vue&type=script&lang=js"
export * from "./PredictorSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports